export default {
  VIDEO_TYPES: ['mp4', 'webm', 'ogg'],
};
